export const HasAccess = (actions) => {
  const user = JSON.parse(localStorage.getItem("user"));
  const storedRoles = user?.roles || [];
  const rolesToCheck = storedRoles.map((item) => item.roleName);
  const mergedPermissions = {};

  const superAdminPermission = {
    create: true,
    update: true,
    delete: true,
    view: true,
    share: true,
    import: true,
    export: true,
  };

  actions?.forEach((action) => {
    const access = rolesToCheck.map((roleToCheck) => {
      const role = storedRoles.find((r) => r.roleName === roleToCheck);
      return role?.access?.find((a) => a.title === action);
    });

    access?.forEach((permission) => {
      if (permission) {
        const { title, ...rest } = permission;

        if (!mergedPermissions[title]) {
          mergedPermissions[title] = { ...rest };
        } else {
          Object.keys(rest).forEach((key) => {
            if (mergedPermissions[title][key] !== true) {
              mergedPermissions[title][key] = rest[key];
            }
          });
        }
      }
    });
  });

  return actions.map((action) =>
    user?.role === "superAdmin"
      ? superAdminPermission
      : mergedPermissions[action]
  );
};
